const sessionAuthenticationFailureResponses = new WeakSet();

export function createSessionAuthenticationMiddleware(authenticationToken, invalidateSession) {
    return {
        post: async ({response}) => {
            if (!authenticationToken || response.status !== 401) {
                return response;
            }

            sessionAuthenticationFailureResponses.add(response);
            invalidateSession(authenticationToken);

            return response;
        },
    };
}

export function isSessionAuthenticationError(error) {
    return error?.response instanceof Response
        && sessionAuthenticationFailureResponses.has(error.response);
}
